var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "renting" }, [
    _c("form", [
      _c("h1", { staticClass: "f-weight__500 text-center font-small title" }, [
        _vm._v("租凭合同")
      ]),
      _c("div", { staticClass: "cel cel-right" }, [
        _c("div", { staticClass: "cel-content" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.contractNo,
                expression: "form.contractNo"
              }
            ],
            staticClass: "width-mini",
            attrs: { name: "contractNo", type: "text" },
            domProps: { value: _vm.form.contractNo },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "contractNo", $event.target.value)
              }
            }
          })
        ]),
        _c("div", { staticClass: "cel-content f-weight__600 font-small" }, [
          _vm._v("编号：")
        ])
      ]),
      _c("div", { staticClass: "all-indent" }, [
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("出租人：")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.czr,
                  expression: "form.czr"
                }
              ],
              staticClass: "width-full",
              attrs: { name: "czr", type: "text" },
              domProps: { value: _vm.form.czr },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "czr", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("签订地点：")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.address,
                  expression: "form.address"
                }
              ],
              staticClass: "width-full",
              attrs: { name: "address", type: "text" },
              domProps: { value: _vm.form.address },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "address", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("承租人：")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.chengzr,
                  expression: "form.chengzr"
                }
              ],
              staticClass: "width-full",
              attrs: { name: "chengzr", type: "text" },
              domProps: { value: _vm.form.chengzr },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "chengzr", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("签订时间：")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.signTime,
                  expression: "form.signTime"
                }
              ],
              staticClass: "width-full",
              attrs: { name: "signTime", type: "text" },
              domProps: { value: _vm.form.signTime },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "signTime", $event.target.value)
                }
              }
            })
          ])
        ])
      ]),
      _c("div", [
        _vm._v("\n      第一条　租赁物 "),
        _c("br"),
        _vm._v("\n      １．名称："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.name,
              expression: "form.name"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "name", type: "text" },
          domProps: { value: _vm.form.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "name", $event.target.value)
            }
          }
        }),
        _c("br"),
        _vm._v("\n      ２．数量及相关配套设施："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.slpt,
              expression: "form.slpt"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "slpt", type: "text" },
          domProps: { value: _vm.form.slpt },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "slpt", $event.target.value)
            }
          }
        }),
        _c("br"),
        _vm._v("\n      ３．质量状况："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.zlzk,
              expression: "form.zlzk"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "zlzk", type: "text" },
          domProps: { value: _vm.form.zlzk },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "zlzk", $event.target.value)
            }
          }
        }),
        _c("br"),
        _c("br"),
        _vm._v("\n\n      第二条　租赁期限"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.limitYear,
              expression: "form.limitYear"
            }
          ],
          staticClass: "width-mini",
          attrs: { name: "limitYear", type: "text" },
          domProps: { value: _vm.form.limitYear },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "limitYear", $event.target.value)
            }
          }
        }),
        _vm._v("年"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.limitMonth,
              expression: "form.limitMonth"
            }
          ],
          staticClass: "width-mini",
          attrs: { name: "limitMonth", type: "text" },
          domProps: { value: _vm.form.limitMonth },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "limitMonth", $event.target.value)
            }
          }
        }),
        _vm._v("个月"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.limitDays,
              expression: "form.limitDays"
            }
          ],
          staticClass: "width-mini",
          attrs: { name: "limitDays", type: "text" },
          domProps: { value: _vm.form.limitDays },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "limitDays", $event.target.value)
            }
          }
        }),
        _vm._v("日，\n      自"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.startTime,
              expression: "form.startTime"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "startTime", type: "text" },
          domProps: { value: _vm.form.startTime },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "startTime", $event.target.value)
            }
          }
        }),
        _vm._v("至"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.endTime,
              expression: "form.endTime"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "endTime", type: "text" },
          domProps: { value: _vm.form.endTime },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "endTime", $event.target.value)
            }
          }
        }),
        _c("br"),
        _vm._v(
          "\n      （提示：租赁期限不得超过二十年。超过二十年的，超过部分无效）。 "
        ),
        _c("br"),
        _c("br"),
        _vm._v("\n\n      第三条　租赁物的用途或性质："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.use,
              expression: "form.use"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "use", type: "text" },
          domProps: { value: _vm.form.use },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "use", $event.target.value)
            }
          }
        }),
        _c("br"),
        _vm._v("\n      租赁物的使用方法："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.useMethod,
              expression: "form.useMethod"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "useMethod", type: "text" },
          domProps: { value: _vm.form.useMethod },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "useMethod", $event.target.value)
            }
          }
        }),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n\n      第四条　租金、租金支付期限及方式\n      １．租金（大写）："
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.moneyZh,
              expression: "form.moneyZh"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "moneyZh", type: "text" },
          domProps: { value: _vm.form.moneyZh },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "moneyZh", $event.target.value)
            }
          }
        }),
        _c("br"),
        _vm._v("\n      ２．租金支付期限："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.payLimit,
              expression: "form.payLimit"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "payLimit", type: "text" },
          domProps: { value: _vm.form.payLimit },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "payLimit", $event.target.value)
            }
          }
        }),
        _c("br"),
        _vm._v("\n      ３．租金支付方式："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.payMethod,
              expression: "form.payMethod"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "payMethod", type: "text" },
          domProps: { value: _vm.form.payMethod },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "payMethod", $event.target.value)
            }
          }
        }),
        _c("br"),
        _c("br"),
        _vm._v("\n\n      第五条　租赁物交付的时间、地点、方式及验收："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.zlAddress,
              expression: "form.zlAddress"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "zlAddress", type: "text" },
          domProps: { value: _vm.form.zlAddress },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "zlAddress", $event.target.value)
            }
          }
        }),
        _c("br"),
        _c("br"),
        _vm._v("\n\n      第六条　租赁物的维修 "),
        _c("br"),
        _vm._v("\n      １．出租人维修范围、时间及费用承担："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.czrfycd,
              expression: "form.czrfycd"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "czrfycd", type: "text" },
          domProps: { value: _vm.form.czrfycd },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "czrfycd", $event.target.value)
            }
          }
        }),
        _c("br"),
        _vm._v("\n      ２．承租人维修范围及费用承担："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.cczrfycd,
              expression: "form.cczrfycd"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "cczrfycd", type: "text" },
          domProps: { value: _vm.form.cczrfycd },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "cczrfycd", $event.target.value)
            }
          }
        }),
        _c("br"),
        _c("br"),
        _vm._v("\n\n      第七条　因租赁物维修影响承租人使用"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.yxczrts,
              expression: "form.yxczrts"
            }
          ],
          staticClass: "width-mini",
          attrs: { name: "yxczrts", type: "text" },
          domProps: { value: _vm.form.yxczrts },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "yxczrts", $event.target.value)
            }
          }
        }),
        _vm._v("天的，出租人应相应减少租金或延长租期。其计算方法是：\n      "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.jsfs,
              expression: "form.jsfs"
            }
          ],
          staticClass: "width-mini",
          attrs: { name: "jsfs", type: "text" },
          domProps: { value: _vm.form.jsfs },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "jsfs", $event.target.value)
            }
          }
        }),
        _c("br"),
        _c("br"),
        _vm._v("\n\n      第八条　租赁物的改善或增设他物 "),
        _c("br"),
        _vm._v("\n      出租人"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.sfyxzstw,
              expression: "form.sfyxzstw"
            }
          ],
          staticClass: "width-mini",
          attrs: { name: "sfyxzstw", type: "text" },
          domProps: { value: _vm.form.sfyxzstw },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "sfyxzstw", $event.target.value)
            }
          }
        }),
        _vm._v(
          "（是／否）允许承租人对租赁物进行改善或增设他物。改善或增设他物不得因此损坏租赁物。 "
        ),
        _c("br"),
        _vm._v(
          "\n      租赁合同期满时，对租赁物的改善或增设的他物的处理办法是："
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.dqclbf,
              expression: "form.dqclbf"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "dqclbf", type: "text" },
          domProps: { value: _vm.form.dqclbf },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "dqclbf", $event.target.value)
            }
          }
        }),
        _c("br"),
        _c("br"),
        _vm._v("\n\n      第九条　出租人"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.sfyxzzzlw,
              expression: "form.sfyxzzzlw"
            }
          ],
          staticClass: "width-mini",
          attrs: { name: "sfyxzzzlw", type: "text" },
          domProps: { value: _vm.form.sfyxzzzlw },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "sfyxzzzlw", $event.target.value)
            }
          }
        }),
        _vm._v("（是／否）允许承租人转租租赁物。 "),
        _c("br"),
        _vm._v("\n      第十条　违约责任："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.wyzr,
              expression: "form.wyzr"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "wyzr", type: "text" },
          domProps: { value: _vm.form.wyzr },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "wyzr", $event.target.value)
            }
          }
        }),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n\n      第十一条　合同争议的解决方式：本合同在履行过程中发生的争议，由双方当事人协商解决；也可由当地工商行政管理部门调解；协商或调解不成的，按下列第\n      "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.jjfsdjz,
              expression: "form.jjfsdjz"
            }
          ],
          staticClass: "width-mini",
          attrs: { name: "jjfsdjz", type: "text" },
          domProps: { value: _vm.form.jjfsdjz },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "jjfsdjz", $event.target.value)
            }
          }
        }),
        _vm._v("种方式解决： "),
        _c("br"),
        _c("br"),
        _vm._v("\n      （一）提交"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.arbitration,
              expression: "form.arbitration"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "arbitration", type: "text" },
          domProps: { value: _vm.form.arbitration },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "arbitration", $event.target.value)
            }
          }
        }),
        _vm._v("仲裁委员会仲裁； "),
        _c("br"),
        _vm._v("\n      （二）依法向人民法院起诉。 "),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n\n      第十二条　租赁期届满，双方有意续订的，可在租赁期满前"
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.xztianshu,
              expression: "form.xztianshu"
            }
          ],
          staticClass: "width-mini",
          attrs: { name: "xztianshu", type: "text" },
          domProps: { value: _vm.form.xztianshu },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "xztianshu", $event.target.value)
            }
          }
        }),
        _vm._v("日续订租赁合同。 "),
        _c("br"),
        _c("br"),
        _vm._v("\n\n      第十三条　租赁期满租赁物的返还时间为："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.fanhuanshijian,
              expression: "form.fanhuanshijian"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "fanhuanshijian", type: "text" },
          domProps: { value: _vm.form.fanhuanshijian },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "fanhuanshijian", $event.target.value)
            }
          }
        }),
        _c("br"),
        _c("br"),
        _vm._v("\n\n      第十四条　其他约定事项："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.otherDesc,
              expression: "form.otherDesc"
            }
          ],
          staticClass: "width-medium",
          attrs: { name: "otherDesc", type: "text" },
          domProps: { value: _vm.form.otherDesc },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "otherDesc", $event.target.value)
            }
          }
        }),
        _c("br"),
        _c("br")
      ]),
      _c("ul", { staticClass: "sys-list-signer" }, [
        _c("li", [
          _vm._v("\n        出租人 "),
          _c("br"),
          _vm._v("\n        住所： "),
          _c("br"),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.chuzrzs,
                expression: "form.chuzrzs"
              }
            ],
            staticClass: "width-full",
            attrs: { name: "chuzrzs" },
            domProps: { value: _vm.form.chuzrzs },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "chuzrzs", $event.target.value)
              }
            }
          }),
          _c("br"),
          _vm._v("\n        法定代表人（签名）： "),
          _c("br"),
          _vm._v("\n        委托代理人（签名）： "),
          _c("br"),
          _vm._v("\n        电话： "),
          _c("br"),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.chuzrmobile,
                expression: "form.chuzrmobile"
              }
            ],
            staticClass: "width-full",
            attrs: { name: "chuzrmobile", type: "text" },
            domProps: { value: _vm.form.chuzrmobile },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "chuzrmobile", $event.target.value)
              }
            }
          })
        ]),
        _c("li", [
          _vm._v("\n        承租人 "),
          _c("br"),
          _vm._v("\n        住所： "),
          _c("br"),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.chengzraddress,
                expression: "form.chengzraddress"
              }
            ],
            staticClass: "width-full",
            attrs: { name: "chengzraddress" },
            domProps: { value: _vm.form.chengzraddress },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "chengzraddress", $event.target.value)
              }
            }
          }),
          _c("br"),
          _vm._v("\n        法定代表人（签名）： "),
          _c("br"),
          _vm._v("\n        委托代理人（签名）： "),
          _c("br"),
          _vm._v("\n        电话： "),
          _c("br"),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.chengzurmobile,
                expression: "form.chengzurmobile"
              }
            ],
            staticClass: "width-full",
            attrs: { name: "chengzurmobile", type: "text" },
            domProps: { value: _vm.form.chengzurmobile },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "chengzurmobile", $event.target.value)
              }
            }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e522a272", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e522a272","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/sys-contract/renting.vue
// module id = q7r7
// module chunks = 57